"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

const PopoverBoundaryContext = (0, _react.createContext)({
  boundaryRef: null,
  globalBoundaryRef: null
});
const globalBoundaryRef = {
  current: null
};
/**
 * Defines limits for the Popover component.
 * Wrap your application on top level to define global bounds, for example root of the application
 * And also you can wrap some modal windows or other blocks, to define smaller bounds.
 * You should set globalBoundaryRef or boundaryRef of this context
 */

function PopoverBoundaryProvider({
  children
}) {
  const boundaryRef = (0, _react.useRef)(null);
  return /*#__PURE__*/_react.default.createElement(PopoverBoundaryContext.Provider, {
    value: {
      boundaryRef,
      globalBoundaryRef
    }
  }, children);
}

var _default = {
  Provider: PopoverBoundaryProvider,
  Consumer: PopoverBoundaryContext.Consumer,
  Context: PopoverBoundaryContext
};
exports.default = _default;